export default "__VITE_ASSET__c297f77e__"